import styles from "../../assets/styles/Wallet/Wallet.module.scss";
import React, { useMemo, useState } from "react";
import {
  AppPage,
  BusinessInsightComponent as BIC,
  PageLoader,
  MimaButton,
  MimaTable,
} from "../../components";
import { amountFormatter } from "../../utils/utils";
import moment from "moment";
import { AnimatePresence } from "framer-motion";
import {
  CreateInflowModalContainer,
  InflowReviewModalContainer,
} from "../../containers";
import constant from "../../utils/constant";

const CreateInflow = ({
  closeModal,
  createInflowModal,
  goToCreateInflow,
  isLoading,
  data,
  isFetching,
  onLimitChange,
  limit,
  setSearchQuery,
  currentPage,
  setCurrentPage,
  goToReviewInflow,
  reviewInflowModal,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value.filter((X) => X.type === "INFLOW") || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Creation Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const createdAt = cell.row.original.createdAt;
        const formattedCreatedAt =
          moment(createdAt).format("DD/MM/YYYY HH:MM A");
        return <span>{formattedCreatedAt}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business?.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Amount",
      accessor: "amountPaid",
      Cell: ({ cell }) => {
        const amount = cell.row.original.amountPaid;
        const currencyCode = cell.row.original.currencyCode;
        const formattedAmount = amountFormatter(currencyCode).format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Vendor",
      accessor: "vendor",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const styleClass = `status ${status === "FULLY-PAID" || status === "PAID" ? "status__green" : status === "PENDING" ? "status__dark__yellow" : status === "VOID" || status === "REVERSED" ? "status__grey" : "status__dark__yellow"}`;
        return <span className={styleClass}>{status}</span>;
      },
    },
    {
      Header: "Approved By",
      accessor: "updatedBy",
      Cell: ({ cell }) => {
        const updatedBy = cell.row.original.updatedBy;
        const updatedAt = cell.row.original.updatedAt;
        const formattedUpdatedAt =
          moment(updatedAt).format("DD/MM/YYYY HH:MM A");
        return (
          <span style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: 600 }}>
              {updatedBy?.firstname
                ? `${updatedBy?.firstname} ${updatedBy?.lastname} `
                : "N/A"}
            </span>
            {updatedBy?.firstname && <span>{formattedUpdatedAt}</span>}
          </span>
        );
      },
    },
    {
      Header: "Action",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        const status = cell.row.original.status;

        return (
          <>
            {status === "PENDING" && (
              <span
                className="tableAction__text"
                onClick={() => {
                  goToReviewInflow(item);
                }}
              >
                Review Inflow
              </span>
            )}
          </>
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Create Inflow">
      {isLoading ? (
        <PageLoader title="While we set things up for you" />
      ) : (
        <>
          <div className={styles.cards}>
            <BIC
              title="Inflow Count"
              amount={tableData.length}
              styleClass="cards_blue_1"
            />
          </div>
        </>
      )}
      <MimaButton title="Create Inflow" onClick={goToCreateInflow} mt={5} />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Inflow"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {(createInflowModal || reviewInflowModal) && (
        <div className="modal">
          <AnimatePresence>
            {createInflowModal && (
              <CreateInflowModalContainer closeModal={closeModal} />
            )}
            {reviewInflowModal && (
              <InflowReviewModalContainer closeModal={closeModal} />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};

export default CreateInflow;
